<template>
    <div>
        <!-- 检索条件 -->
        <div>
            <el-form :inline="true" @submit.native.prevent :model="queryMap">
                <el-row>
                    <el-form-item :label="item.fieldShow + ':'" v-for="(item, index) in searchTermList" :key="index"
                        v-show="item.isShow == 1">
                        <el-input style="width:200px" v-if="item.fieldType == 'string' && item.isShow"
                            @keyup.enter.prevent="toClick(item.fieldEntity)" @blur="inblur" @focus="infocus"
                            @change="((val) => { handleChange(val, item.fieldEntity) })"
                            :placeholder="'请输入' + item.fieldShow" v-model.trim="queryMap[item.fieldEntity]" size="mini">
                        </el-input>
                        <!-- 检索方案 -->
                        <el-input v-else-if="item.fieldType == 'search'" clearable v-model="queryMap[item.fieldEntity]"
                            @keyup.enter.native="openSearch(item.searchId, index, item.fieldEntity, item.setField)">
                            <el-button @click="openSearch(item.searchId, index, item.fieldEntity, item.setField)"
                                slot="append" icon="el-icon-search"></el-button>
                        </el-input>
                        <!-- 开始时间 -->
                        <el-date-picker v-else-if="item.fieldEntity == 'start'" size="mini"
                            v-model="queryMap[item.fieldEntity]" format="yyyy 年 MM 月 dd 日"
                            @change="((val) => { handleChange(val, item.fieldEntity) })" value-format="timestamp"
                            type="date" placeholder="选择日期"></el-date-picker>
                        <!-- 结束时间 -->
                        <el-date-picker v-else-if="item.fieldEntity == 'end'" @change="changeTime" size="mini"
                            v-model="queryMap[item.fieldEntity]" format="yyyy 年 MM 月 dd 日" value-format="timestamp"
                            type="date" placeholder="选择日期"></el-date-picker>
                        <!-- 检索方案 -->
                        <el-date-picker v-else-if="item.fieldType == 'date' && item.isShow"
                            @change="((val) => { handleChange(val, item.fieldEntity) })" size="mini"
                            v-model="queryMap[item.fieldEntity]" format="yyyy 年 MM 月 dd 日" value-format="timestamp"
                            type="date" placeholder="选择日期">
                        </el-date-picker>
                        <el-input style="width:200px" v-else-if="item.fieldType == 'number' && item.isShow"
                            @keyup.enter.prevent="toClick(item.fieldEntity)" @blur="inblur" @focus="infocus"
                            @change="((val) => { handleChange(val, item.fieldEntity) })"
                            :placeholder="'请输入' + item.fieldShow" v-model="queryMap[item.fieldEntity]" type="number"
                            size="mini">
                        </el-input>
                        <el-select size="mini" v-else-if="item.fieldType == 'formatter' && item.isShow"
                            @change="((val) => { handleChange(val, item.fieldEntity) })"
                            v-model="queryMap[item.fieldEntity]" placeholder="请选择">
                            <el-option v-for="matItem in JSON.parse(item.formatterContent)" :key="matItem.key"
                                :label="matItem.key" :value="matItem.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <!-- 表格 -->
        <el-table ref="moviesTable" height="520" size="mini" :row-class-name="rowClassName" :row-style="rowStyle"
            @row-click="clickEvent" @selection-change="handleSelectionChange" style="width: 100%" :data="tableData"
            border>
            <template v-for="(item, index) in Columns">
                <!-- 数字 -->
                <el-table-column v-if="item.fieldType == 'formatter' && item.isShow" align="center" :key="index"
                    min-width="120" :prop="item.entityField" :sortable="item.isSort" :label="item.showField"
                    :show-overflow-tooltip="true">
                    <!-- 各种状态判断 -->
                    <template slot-scope="scope">
                        <el-tag size="mini" type="primary">{{ $common.getIsGsp(item.formatterContent,scope.row[item.entityField]) }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column v-else-if="item.fieldType == 'string' && item.isShow" align="center" :key="index + 'a'"
                    min-width="120" :prop="item.entityField" :sortable="item.isSort" :label="item.showField"
                    :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column v-else-if="item.fieldType == 'date' && item.isShow" align="center" :key="index + 'b'"
                    min-width="120" :prop="item.entityField" :sortable="item.isSort" :label="item.showField"
                    :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{ $common.getLocalTime(scope.row[item.entityField]) }}</span>
                    </template>
                </el-table-column>
                <el-table-column v-else-if="item.fieldType == 'number' && item.isShow" align="center" :key="index + 'c'"
                    min-width="120" :prop="item.entityField" :sortable="item.isSort" :label="item.showField"
                    :show-overflow-tooltip="true">
                </el-table-column>
            </template>
            <el-table-column fixed="right" label="操作" width="110" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" @click.stop="handleSelectClick(scope.row)">确认选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
            :page-sizes="pageSizes" background :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
            :total="total">
        </el-pagination>

        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth"
            :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData"
                @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>
</template>
<script>
var searchTermListp = [
    {
        fieldEntity: "start",
        fieldName: "开始时间",
        fieldShow: "开始时间",
        fieldType: "date",
        formatterContent: "",
        isShow: 1,
        value: "",
    },
    {
        fieldEntity: "end",
        fieldName: "结束时间",
        fieldShow: "结束时间",
        fieldType: "date",
        formatterContent: "",
        isShow: 1,
        value: "",
    },
    {
        fieldEntity: "smName",
        fieldName: "供应商",
        fieldShow: "供应商",
        fieldType: "search",
        formatterContent: "",
        searchId: 3386264207560704,
        setField: "smName,smId",
        isShow: 1,
        value: "",
    },
];
var searchTermLists = [
    {
        fieldEntity: "start",
        fieldName: "开始时间",
        fieldShow: "开始时间",
        fieldType: "date",
        formatterContent: "",
        isShow: 1,
        value: "",
    },
    {
        fieldEntity: "end",
        fieldName: "结束时间",
        fieldShow: "结束时间",
        fieldType: "date",
        formatterContent: "",
        isShow: 1,
        value: "",
    },
    {
        fieldEntity: "cmName",
        fieldName: "客户",
        fieldShow: "客户",
        fieldType: "search",
        searchId: 3391151360249856,
        setField: "cmName,cmId",
        formatterContent: "",
        isShow: 1,
        value: "",
    },
];
var mainTablep = [
    {
        "entityField": "dpsmId",
        "chineseField": "采购结算申请单号",
        "showField": "采购结算申请单号",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 1,
        "fieldWeight": 160,
        "isRift": 1,
        "riftField": "dpsmId",
    },
    {
        "entityField": "dpsmDate",
        "chineseField": "申请日期",
        "showField": "申请日期",
        "isShow": 1,
        "fieldType": "date",
        "formatterContent": "",
        "fieldSort": 2,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "smId",
        "chineseField": "供应商id",
        "showField": "供应商id",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 3,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "smName",
        "chineseField": "供应商",
        "showField": "供应商",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 4,
        "fieldWeight": 180,
        "isRift": 0,
    },
    {
        "entityField": "coId",
        "chineseField": "货主",
        "showField": "货主",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 5,
        "fieldWeight": 150,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "coName",
        "chineseField": "货主",
        "showField": "货主",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 6,
        "fieldWeight": 150,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "opmId",
        "chineseField": "业务员",
        "showField": "业务员",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 8,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "opmName",
        "chineseField": "业务员",
        "showField": "业务员",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 9,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "salesId",
        "chineseField": "对方业务员",
        "showField": "对方业务员",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 10,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "salesName",
        "chineseField": "对方业务员",
        "showField": "对方业务员",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 11,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "depId",
        "chineseField": "业务部门",
        "showField": "业务部门",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 12,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "depName",
        "chineseField": "业务部门",
        "showField": "业务部门",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 12,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "creater",
        "chineseField": "创建人",
        "showField": "创建人",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 13,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "createrName",
        "chineseField": "创建人",
        "showField": "创建人",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 14,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "createTime",
        "chineseField": "创建时间",
        "showField": "创建时间",
        "isShow": 1,
        "fieldType": "date",
        "formatterContent": "",
        "fieldSort": 15,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "updateTime",
        "chineseField": "修改时间",
        "showField": "修改时间",
        "isShow": 0,
        "fieldType": "date",
        "formatterContent": "",
        "fieldSort": 16,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "dpsmRemark",
        "chineseField": "备注",
        "showField": "备注",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 19,
        "fieldWeight": 150,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "settleMode",
        "chineseField": "结算方式",
        "showField": "结算方式",
        "isShow": 1,
        "fieldType": "formatter",
        "formatterContent": "[{\"key\":0,\"value\":\"按单据\"},{\"key\":1,\"value\":\"按明细\"}]",
        "fieldSort": 20,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "totalMoney",
        "chineseField": "总金额",
        "showField": "总金额",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": null,
        "fieldSort": 20,
        "fieldWeight": 120,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "payMethod",
        "chineseField": "支付方式",
        "showField": "支付方式",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 21,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "preMoney",
        "chineseField": "使用预付金额",
        "showField": "使用预付金额",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": null,
        "fieldSort": 21,
        "fieldWeight": 150,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "sbiAddress",
        "chineseField": "银行地址",
        "showField": "银行地址",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 22,
        "fieldWeight": 180,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "payMoney",
        "chineseField": "实际付款金额",
        "showField": "实际付款金额",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": null,
        "fieldSort": 22,
        "fieldWeight": 120,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "sbiNumber",
        "chineseField": "银行账号",
        "showField": "银行账号",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 23,
        "fieldWeight": 180,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "sbiName",
        "chineseField": "公司银行",
        "showField": "公司银行",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 24,
        "fieldWeight": 180,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "dpsmState",
        "chineseField": "状态",
        "showField": "状态",
        "isShow": 1,
        "fieldType": "formatter",
        "formatterContent": "[{\"key\":0,\"value\":\"初始\"},{\"key\":1,\"value\":\"审核退回\"},{\"key\":2,\"value\":\"提交审核\"},{\"key\":3,\"value\":\"审核通过\"},{\"key\":4,\"value\":\"已被提取\"}]",
        "fieldSort": 25,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "desmReserves1",
        "chineseField": "预留字段1",
        "showField": "预留字段1",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 26,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "desmReserves2",
        "chineseField": "预留字段2",
        "showField": "预留字段2",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 27,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "desmReserves3",
        "chineseField": "预留字段3",
        "showField": "预留字段3",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 28,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "desmReserves4",
        "chineseField": "预留字段4",
        "showField": "预留字段4",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 29,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "desmReserves5",
        "chineseField": "预留字段5",
        "showField": "预留字段5",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 30,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "desmReserves6",
        "chineseField": "预留字段6",
        "showField": "预留字段6",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 31,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    }
];
var mainTables = [
    {
        "entityField": "dsapmId",
        "chineseField": "销售结算申请单号",
        "showField": "销售结算申请单号",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 1,
        "fieldWeight": 180,
        "isRift": 1,
        "riftField": "dsapmId",
    },
    {
        "entityField": "dsapmDate",
        "chineseField": "申请日期",
        "showField": "申请日期",
        "isShow": 1,
        "fieldType": "date",
        "formatterContent": "",
        "fieldSort": 2,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "cmId",
        "chineseField": "客户id",
        "showField": "客户id",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 3,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "cmName",
        "chineseField": "客户",
        "showField": "客户",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 4,
        "fieldWeight": 150,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "salesId",
        "chineseField": "对方业务员",
        "showField": "对方业务员",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 5,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "salesName",
        "chineseField": "对方业务员",
        "showField": "对方业务员",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 6,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "coId",
        "chineseField": "货主id",
        "showField": "货主id",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 7,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "coName",
        "chineseField": "货主",
        "showField": "货主",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 8,
        "fieldWeight": 150,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "opmId",
        "chineseField": "业务员",
        "showField": "业务员",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 9,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "opmName",
        "chineseField": "业务员",
        "showField": "业务员",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 10,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "ormId",
        "chineseField": "组织",
        "showField": "组织",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 11,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "depId",
        "chineseField": "部门",
        "showField": "部门",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 12,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "depName",
        "chineseField": "业务部门",
        "showField": "业务部门",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 13,
        "fieldWeight": 180,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "creater",
        "chineseField": "创建人",
        "showField": "创建人",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 14,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "createTime",
        "chineseField": "创建时间",
        "showField": "创建时间",
        "isShow": 1,
        "fieldType": "date",
        "formatterContent": "",
        "fieldSort": 15,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "totalMoney",
        "chineseField": "总金额",
        "showField": "总金额",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 16,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "totalCount",
        "chineseField": "总条目数",
        "showField": "总条目数",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 17,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "dsapmRemark",
        "chineseField": "备注",
        "showField": "备注",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 18,
        "fieldWeight": 150,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "settleMode",
        "chineseField": "结算方式",
        "showField": "结算方式",
        "isShow": 1,
        "fieldType": "formatter",
        "formatterContent": "[{\"key\":0,\"value\":\"按单据\"},{\"key\":1,\"value\":\"按明细\"}]",
        "fieldSort": 19,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "payMethod",
        "chineseField": "支付方式",
        "showField": "支付方式",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 20,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "preMoney",
        "chineseField": "预收金额",
        "showField": "预收金额",
        "isShow": 1,
        "fieldType": "number",
        "formatterContent": null,
        "fieldSort": 20,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "cbiAddress",
        "chineseField": "银行地址",
        "showField": "银行地址",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 21,
        "fieldWeight": 180,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "payMoney",
        "chineseField": "实际收款金额",
        "showField": "实际收款金额",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": null,
        "fieldSort": 21,
        "fieldWeight": 120,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "cbiNumber",
        "chineseField": "银行账号",
        "showField": "银行账号",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 22,
        "fieldWeight": 180,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "cbiName",
        "chineseField": "公司银行",
        "showField": "公司银行",
        "isShow": 1,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 23,
        "fieldWeight": 180,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "dsapmState",
        "chineseField": "状态",
        "showField": "状态",
        "isShow": 1,
        "fieldType": "formatter",
        "formatterContent": "[{\"key\":0,\"value\":\"初始\"},{\"key\":1,\"value\":\"审核退回\"},{\"key\":2,\"value\":\"提交审核\"},{\"key\":3,\"value\":\"审核通过\"},{\"key\":4,\"value\":\"已被提取\"}]",
        "fieldSort": 24,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "dsapmReserves1",
        "chineseField": "预留字段1",
        "showField": "预留字段1",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 25,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "dsapmReserves2",
        "chineseField": "预留字段2",
        "showField": "预留字段2",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 26,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "dsapmReserves3",
        "chineseField": "预留字段3",
        "showField": "预留字段3",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 27,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "dsapmReserves4",
        "chineseField": "预留字段4",
        "showField": "预留字段4",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 28,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "dsapmReserves5",
        "chineseField": "预留字段5",
        "showField": "预留字段5",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 29,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    },
    {
        "entityField": "dsapmReserves6",
        "chineseField": "预留字段6",
        "showField": "预留字段6",
        "isShow": 0,
        "fieldType": "string",
        "formatterContent": "",
        "fieldSort": 30,
        "fieldWeight": 100,
        "isRift": 0,
        "riftField": null,
    }
];
export default {
    name: "ExtractSettleapply",
    components: {},
    data() {
        return {
            queryMap: {
                smName: "",
                cmName: "",
                opmId: "",
                ormId: "",
                end: "",
                page: 1,
                rows: 30,
                smId: "",   //	供应商
                start: "",
            },
            detailsub: true,
            activeName: "0",
            showdetail: false,
            detailData: [],
            currentPage: 1,
            pageSizes: [10, 25, 50, 100],
            pageSize: 10,
            total: 0,
            tableData: [],
            isPagination: "",
            searchTermList: [], //检索条件
            Columns: [],
            isDetail: false,
            multipleSelection: [], //数组内层
            objList: [], //外层数组
            selectedRow: [], // 当前已选择行
            selectedIndex: 0, // 当前选择行的index

            seId: "",
            seWidth: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            smId: '',
            sField: '',
            parentSearchData: {},

        };
    },
    props: {
        isSell: {
            type: Boolean,
            default: false,
        },
        detailTableColumn: {
            type: Array,
            default: [],
        },
    },
    watch: {
        showdetail: {
            handler(newVal) {
                this.activeName = newVal == true ? "1" : "0"
            }
        },
        'queryMap.smName': {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.queryMap.smId = ''
                }
            },
            deep: true,
        },
        'queryMap.cmName': {
            handler: function (newValue, oldValue) {
                if (newValue == '') {
                    this.queryMap.cmId = ''
                }
            },
            deep: true,
        },
    },
    mounted() {
        addEventListener('keyup', this.keyUpChild)
    },
    beforeDestroy() {
        removeEventListener('keyup', this.keyUpChild)
    },
    created() {
        // 处理组件需要的数据
        this.queryMap.ormId = JSON.parse(sessionStorage.getItem("loginInfo")).ormId;
        this.queryMap.opmId = JSON.parse(sessionStorage.getItem("userInfo")).opmId;

        this.queryMap.start = new Date(new Date().toLocaleDateString()).getTime() - 30 * 24 * 3600 * 1000;
        this.queryMap.end = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1;

        this.Columns = this.isSell ? mainTables : mainTablep;
        this.searchTermList = this.isSell ? searchTermLists : searchTermListp;
        this.Columns.forEach((item) => {
            item.isShow = item.isShow == 1 ? true : false;
            item.isSort = item.isSort == 1 ? true : false;
        });
        this.detailTableColumn.forEach((item) => {
            item.isShow = item.isShow == 1 ? true : false;
            item.isSort = item.isSort == 1 ? true : false;
        });

        console.log('column', this.Columns, this.detailTableColumn);
        // this.isDetail = isDetail;
        // if (this.isDetail) {
        //     this.showdetail = true;
        //     this.activeName = "1";
        // } else {
        //     this.showdetail = false;
        //     this.activeName = "0";
        // }

        this.getTableMainList();
    },
    methods: {
        toClick(e) {
            this.searchData()
            this.$nextTick(() => {
                this.$refs[e][0].blur()
            })
        },
        inblur() {
            this.$nextTick(() => {
                addEventListener('keyup', this.keyUpChild)
            })
        },
        infocus() {
            removeEventListener('keyup', this.keyUpChild)
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            console.log(sId, index, type, sField);
            this.DialogVisible = true
            this.seId = sId
            this.sField = sField
            this.parentSearchData[type] = this.queryMap[type]
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.queryMap[item] = val[item]
            })
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
            // this.sendDataInfo.pisOrderDetail[this.seIndex].bgmName = val.bgmName
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.queryMap.end = time;
            }
        },
        clickEvent(row, column, event, params) {
            this.showdetail = row.settleMode == 1 ? true : false
            this.isDetail = this.showdetail
            this.selectedIndex = row.rowIndex;
            let refsElTable = this.$refs.moviesTable; // 获取表格对象
            let findRow = {}
            findRow = this.selectedRow.find(c => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
            this.getTableDetailList(row.rowIndex);
            this.$refs.moviesTable.doLayout();
        },
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        // 双击主表格确认
        async handleSelectClick(row) {
            console.log(row);
            // 是否可选择明细
            if (this.tableData && this.tableData.length) {
                this.getTableDetailList(row.rowIndex);
            }
            // row.arrlistbychen = this.detailData;
            this.$emit("TranData", row);
        },
        // 勾选明细
        handleSelectionChange1(val) {
            this.multipleSelection = val;
            if (val.length) {
                this.detailsub = false;
            } else {
                this.detailsub = true;
            }
        },
        sureDetail() {
            this.objList.arrlistbychen = this.multipleSelection;
            this.$emit("TranData", this.objList);
        },
        // 检索条件赋值
        handleChange(value, name) {
            // value默认参，name当前所需的name
            this.queryMap[name] = value;
        },
        //   查询
        searchData() {
            this.currentPage = 1;
            this.queryMap.page = 1;
            this.getTableMainList();
        },
        // 查询弹窗表格
        async getTableMainList() {
            let res = this.isSell ? await this.$http.extractSusettleapply(this.queryMap) : await this.$http.extractSynPssettleapply(this.queryMap);
            this.total = res.result.total;
            this.tableData = res.result.list; //默认第一条
            if (this.tableData && this.tableData.length) {
                this.isDetail = this.objList.settleMode == 1 ? true : false;
                this.showdetail = this.isDetail
                this.getTableDetailList(0)
            } else {
                this.objList = [];
            }
            this.$nextTick(() => {
                let refsElTable = this.$refs.moviesTable
                refsElTable && refsElTable.clearSelection();
                refsElTable && refsElTable.toggleRowSelection(this.tableData[this.selectedIndex]);
                this.$refs.moviesTable.doLayout();
            })
        },
        // 获取明细表格
        getTableDetailList(index) {
            this.objList = this.tableData[index]
            if (this.isSell) {
                if (this.isDetail) {
                    this.detailData = this.objList.suSettleInvoiceDetailVos
                } else {
                    this.detailData = this.objList.suSettleInvoiceVos
                }
            } else {
                if (this.isDetail) {
                    this.detailData = this.objList.psSettleInvoiceDetail
                } else {
                    this.detailData = this.objList.psSettlerInvoice
                }
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.queryMap.rows = val;
            this.getTableMainList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.queryMap.page = val;
            this.getTableMainList();
        },
        //   -----------------------------------------------------
        // 表格方法
        rowClassName({
            row,
            rowIndex
        }) {
            let rowName = "",
                findRow = this.selectedRow.find(c => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        rowStyle({
            row,
            rowIndex
        }) {
            Object.defineProperty(row, "rowIndex", { // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },
        getHeaderCellStyle() {
            return "background: skybule; borderBottom: solid 1px #5a5e66;color: #3e5569";
        },
        getHeaderCellStyleD() {
            return "background: skybule;color: #3e5569";
        },
        keyUpChild(e) {
            // 表格为空，不执行下方 
            if (!this.tableData) return
            e.preventDefault();
            if (e.keyCode == 40) { // 下键
                e.preventDefault();
                let refsElTable = this.$refs.moviesTable
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 如果当前没有选中行，则直接选中第一个
                        this.selectedIndex = 0
                    } else if (this.selectedIndex == this.tableData.length - 1) { // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedIndex = 0
                    } else { // 正常递增
                        this.selectedIndex++
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.tableData[this.selectedIndex], false);
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.tableData[this.selectedIndex]); // 把现在当前行勾选
                    this.getTableDetailList(this.selectedIndex);
                })
            } else if (e.keyCode == 38) { // 上键
                e.preventDefault();
                let refsElTable = this.$refs.moviesTable
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) { // 当前没有选中行，则直接选中第一个
                        this.selectedIndex = 0
                    } else if (this.selectedIndex == 0) { // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedIndex = this.tableData.length - 1
                    } else { // 正常递减
                        this.selectedIndex--
                    }
                    if (!refsElTable) return
                    let findRow = this.selectedRow.find(c => c.rowIndex == this.selectedIndex); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(this.tableData[this.selectedIndex], false);
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.tableData[this.selectedIndex]); // 把现在当前行勾选
                    this.getTableDetailList(this.selectedIndex);
                })
            } else if (e.keyCode == 13) {
                if (this.isDetail) {
                    this.multipleSelection = this.detailData
                    this.sureDetail()
                } else {
                    this.handleSelectClick(this.tableData[this.selectedIndex])
                }
            }

        },


    },
};
</script>
<style scoped>
.el-pagination {
    padding: 20px 0px 5px;
}
</style>